require('./documentRow.scss');


// @ vendor
const classNames = require('classnames');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const moment = require('moment');
const Immutable = require('immutable');

// @ core
const { formatText, FormattedText, getLanguage, hasTranslation } = require('core/i18n').i18n;

// @ commons
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { LabelDate } = require('commonsComponents/labelDate');

// @ components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { HYPHEN } = require('constants/index');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const { COUNTRIES_CODES: { ES } } = require('constants/countries');
const { ASNEF, EXPERIAN, SOLIDARITY_EXTRACTS } = require("constants/documents");

// @helpers
const { base64ForPrint } = require('utilities/fileDownloadHelper');
const BrowserUtils = require('utilities/browserUtils');
const { CONTRACTUAL_TYPES } = require("constants/contractualDocuments")
const { recordLinkV2 } = require('utilities/tagging');

const FILE_TYPES_WITH_DOWNLOAD_ICON = [CONTRACTUAL_TYPES.overdraft]

class DocumentRow extends React.Component {

    constructor(props) {
        super(props);
        this.handleMifidDownload = this.handleMifidDownload.bind(this);
        this.handleSendMifid2DocumentByEmail = this.handleSendMifid2DocumentByEmail.bind(this);
        this.openPDFNewTap = this.openPDFNewTap.bind(this);
    }

    getCurrentDocument(currentDocument) {
        let response = (
            <OKTableCell className="document-row__right-action">
                <span />
            </OKTableCell>
        );

        if (currentDocument) {
            response = (
                <OKTableCell>
                    <i className="icon document-row__icon-check" />
                </OKTableCell>
            );
        }

        return response;
    }

    getTranslatedDocumentType() {
        const {documentType, documentTypeId} = this.props
        const documentTypeToTranslate = documentTypeId ? `documents-${documentTypeId}` : documentType;
        const translatedDocumentType = hasTranslation(documentTypeToTranslate) ? formatText(documentTypeToTranslate) : documentTypeToTranslate;
        return translatedDocumentType;
    }

    openPDFNewTap(base64) {
        const currentBlob = base64ForPrint(base64);

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(currentBlob);
        } else {
            const blobURL = window.URL.createObjectURL(currentBlob);
            window.open(blobURL, '_blank');
        }
    }

    getDocumentAlias(documentAlias) {
        let response;

        if (typeof documentAlias !== 'undefined' && documentAlias.length > 6) {
            response = (
                <OKTableCell className="document-row__main">
                    {documentAlias}
                </OKTableCell>
            );
        } else {
            response = (
                <OKTableCell className="document-row__main">
                    {HYPHEN}
                </OKTableCell>
            );
        }

        return response;
    }

    handleMifidDownload() {
        const { immDocument, isFetching } = this.props;
        if (!isFetching) {
            let fileName = this.getFilename();
            let codComunicacion = immDocument.get('codComunicacion');
            this.props.callbackDownloadMifid2File({ codComunicacion: codComunicacion, fileName: fileName, translatedDocumentType: this.getTranslatedDocumentType() });
        }
    }

    getFilename() {
        const { immDocument, documentType, immProfile } = this.props;
        const originCountry = immProfile.get("originCountry") || ES;
        const dateFormat =
            DATE_FORMAT_TYPES[originCountry.toLowerCase()]
                .DATE_FORMAT_TIME_REDUCED;

        const suffix = `${moment().format(dateFormat)}.pdf`;

        if (documentType === "documents-deniedoperation") {
            return `${ASNEF}_${suffix}`;
        } else if (documentType === "documents-experiandeniedoperation") {
            return `${EXPERIAN}_${suffix}`;
        } else if (documentType === "documents-asnefexperiandeniedoperation") {
            return `${ASNEF}_${EXPERIAN}_${suffix}`;
        } else if (documentType === "documents-solidarityextract") {
            return `${SOLIDARITY_EXTRACTS}_${suffix}`;
        } else if (!!documentType && immDocument.get("codComunicacion").endsWith('.pdf')) {
            return `${documentType}_${suffix}`;
        } else {
            return immDocument.get("codComunicacion");
        }
    }

    handleSendMifid2DocumentByEmail() {
        const { immDocument, callbackSendMifid2DocumentByEmail } = this.props;
        const isSendingEmail = immDocument.get('isSendingEmail');
        if (!isSendingEmail) {
            const objectId = immDocument.get('codComunicacion');
            callbackSendMifid2DocumentByEmail({ objectId });
        }
    }

    render() {
        const {
            currentDocument,
            date,
            documentAlias,
            documentType,
            immDocument,
            isContractsInForce,
            isFetching,
            isError,
            linkSquare,
            showCurrentDocument,
            showDocumentationType,
            url,
            documentId,
            isMifid2Document,
            mifid2SendEmailButton,
            documentWithNoDates,
            hideDateCell,
            isStatementMail,
            setSelectedDocument,
            callbackDownloadFile,
            showAlias,
            downloadById,
            history
        } = this.props;

        const emailTooltip = formatText('profileDocumentation-emailTooltip');
        const docTypeClassName = classNames({ 'document-row__main': typeof documentAlias === 'undefined' });
        const aliasCell = showAlias ? this.getDocumentAlias(documentAlias) : null;
        const iconContractsInForceCC = `icon ${__CONTACT_CENTER__ && isContractsInForce ? 'icon-mostrar icon-modifier-regular' : 'icon-mostrar'}`;

        let sendEmailCell = __CONTACT_CENTER__ ? <OKTableCell className="document-row__right-action" /> : null;
        let sendToEmailCell = __CONTACT_CENTER__ ? <OKTableCell className="document-row__right-action" /> : null;
        let urlCell = <OKTableCell className="document-row__right-action" />;

        let currentDocumentCell;
        let documentationTypeCell;
        let file;
        let dateCell = !hideDateCell && (
            <OKTableCell>
                <LabelDate
                    date={date}
                    language={getLanguage()}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            </OKTableCell>
        );

        if (documentWithNoDates) {
            dateCell = (
                <OKTableCell>
                    <FormattedText value="profileDocumentation-notAvailable" />
                </OKTableCell>
            );
        }

        if (showCurrentDocument) {
            currentDocumentCell = this.getCurrentDocument(currentDocument);
        }

        if (showDocumentationType) {
            documentationTypeCell = (
                <OKTableCell className={docTypeClassName}>
                    {this.getTranslatedDocumentType()}
                </OKTableCell>
            );
        }

        if (immDocument.get('file')) {
            file = immDocument.get('file');
        } else {
            let nombreTipoComunicacion = immDocument.get('nombreTipoComunicacion');
            let gestorDocumental = immDocument.get('gestorDocumental');
            let codSubaplicacion = immDocument.get('codSubaplicacion');
            let codComunicacion = immDocument.get('codComunicacion');
            if (nombreTipoComunicacion && gestorDocumental && codSubaplicacion && codComunicacion) {
                file = {
                    filename: `${immDocument.get('nombreTipoComunicacion')}.pdf`,
                    gestorDocumental: immDocument.get('gestorDocumental'),
                    codSubaplicacion: immDocument.get('codSubaplicacion'),
                    codComunicacion: immDocument.get('codComunicacion')
                };
            }
        }

        if (__CONTACT_CENTER__ && isMifid2Document && mifid2SendEmailButton) {
            const tooltipTarget = <i className="icon icon-correo"></i>
            sendEmailCell = (
                <OKTableCell className="document-row__right-action">
                    <OKButton
                        modifier="task"
                        size="small"
                        loaderColor="dark"
                        loaderSize="small"
                        loading={immDocument.get('isSendingEmail')}
                        onClick={this.handleSendMifid2DocumentByEmail}
                    >
                        <OKTooltip
                            target={tooltipTarget}
                            content={emailTooltip}
                            placement="top"
                        />
                    </OKButton>
                </OKTableCell>
            );
        }

        if (__CONTACT_CENTER__ && isStatementMail ) {
            const extractType = immDocument.get('codGrupoComunicacion');
            const tooltipTarget = <i className="icon icon-correo"></i>;
            sendToEmailCell = (
                <OKTableCell className="document-row__right-action">
                    <OKButton
                        modifier="task"
                        size="medium"
                        onClick={() => {
                            setSelectedDocument(immDocument);
                            history.push(`/myprofile/documentation/send-extracts-via-mail/${extractType}`)}
                        }
                    >
                        <OKTooltip
                            target={tooltipTarget}
                            content={emailTooltip}
                            offset={[0, -45]}
                            type="descriptive"
                        />
                    </OKButton>
                </OKTableCell>
            );
        }

        if (isMifid2Document) {
            const iconButton = __CONTACT_CENTER__ ? 'icon-mostrar icon-modifier-regular' : 'icon-descargar';
            const tooltipContent = __CONTACT_CENTER__ ? "profileDocumentation-pdfTooltip" : "profileDocumentation-pdfTooltipDownload";
            const tooltipTarget = (
                <span>
                    <OKIconButton icon={iconButton} onClick={this.handleMifidDownload} />
                </span>
            );
            urlCell = (
                <OKTableCell className="document-row__right-action">
                    <OKTooltip
                        content={tooltipContent}
                        offset={[0, -45]}
                        target={tooltipTarget}
                        type="descriptive"
                    />
                </OKTableCell>
            );
        } else if (downloadById && documentId) {
            const conditionalTooltip = (
                <OKTooltip
                    target={<i className="icon icon-descargar" />}
                    content={"profileDocumentation-pdfTooltipDownload"}
                    offset={[0, -30]}
                    type="descriptive"
                />
            );

            urlCell = (
                <OKTableCell className="document-row__right-action">
                    <OKButton
                        modifier="task"
                        size="medium"
                        loaderColor="dark"
                        loaderSize="small"
                        onClick={() => downloadById(documentId)}
                    >
                        {conditionalTooltip}
                    </OKButton>
                </OKTableCell>
            );
        } else if (url) {
            const conditionalTooltip = (
                <OKTooltip
                    content={"profileDocumentation-pdfTooltip"}
                    offset={[0, -30]}
                    target={<i className={iconContractsInForceCC} />}
                    type="descriptive"
                />
            );
            urlCell = (
                <OKTableCell className="document-row__right-action">
                    <OKButton
                        modifier="task"
                        size={linkSquare ? "compact" : "small"}
                        to={url}
                    >
                        {conditionalTooltip}
                    </OKButton>
                </OKTableCell>
            );
        } else if (file) {
            let conditionalTooltip;
            if (!!isError) {
                const tooltipTarget = <i className="icon icon-error"></i>;
                conditionalTooltip = (
                    <OKTooltip
                        target={tooltipTarget}
                        content="documentRow-errorTooltipText"
                        offset={[0, -45]}
                        title="documentRow-errorTooltipTitle"
                        type="explicative"
                    />
                );
            } else {
                const fileType = immDocument.getIn('file','type')
                const iconButton = __CONTACT_CENTER__ && !FILE_TYPES_WITH_DOWNLOAD_ICON.includes(fileType)
                    ? "icon-mostrar icon-modifier-regular"
                    : "icon-descargar";
                const tooltipContent = __CONTACT_CENTER__ && !FILE_TYPES_WITH_DOWNLOAD_ICON.includes(fileType)
                    ? "profileDocumentation-pdfTooltip"
                    : "profileDocumentation-pdfTooltipDownload";
                const tooltipTarget = <i className={iconButton}></i>;
                conditionalTooltip = (
                    <OKTooltip
                        target={tooltipTarget}
                        content={tooltipContent}
                        offset={[0, -45]}
                        type="descriptive"
                    />
                );
            }
            urlCell = (
                <OKTableCell className="document-row__right-action">
                    <OKButton
                        modifier="task"
                        size="medium"
                        loaderColor="dark"
                        loaderSize="small"
                        loading={isFetching}
                        onClick={() => {
                            if (file instanceof Immutable.Map) {
                                const fileName = file?.get('fileName');
                                recordLinkV2({
                                    categoriaEvento: 'interaccion en certificados',
                                    accionEvento: `certificado de ${fileName}`,
                                    etiquetaEvento: 'descargar',
                                    action: 'download',
                                    format: 'button',
                                    component: `${fileName === 'titularidad' ? 'ownership' : 'balance'}Certificate`,
                                    element: 'download',
                                });
                            }
                            callbackDownloadFile(file, documentType);
                        }}
                    >
                        {conditionalTooltip}
                    </OKButton>
                </OKTableCell>
            );
        }

        return (
            <OKTableRow>
                {dateCell}
                {documentationTypeCell}
                {currentDocumentCell}
                {aliasCell}

                <ContactCenterRender>
                    {sendEmailCell}
                    {sendToEmailCell}
                </ContactCenterRender>

                {urlCell}
            </OKTableRow>
        );
    }
}

DocumentRow.propTypes = {
    callbackDownloadFile: PropTypes.func,
    downloadByUrl: PropTypes.func,
    callbackDownloadMifid2File: PropTypes.func,
    callbackSendMifid2DocumentByEmail: PropTypes.func,
    currentDocument: PropTypes.bool,
    date: PropTypes.string,
    documentAlias: PropTypes.string,
    documentType: PropTypes.string,
    documentId: PropTypes.string,
    documentTypeId: PropTypes.string,
    downloadById: PropTypes.func,
    file: PropTypes.object,
    history: PropTypes.object.isRequired,
    immDocument: PropTypes.object,
    isContractsInForce: PropTypes.bool,
    isFetching: PropTypes.bool,
    isError: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]),
    isPregranted: PropTypes.bool,
    linkSquare: PropTypes.bool,
    showAlias: PropTypes.bool.isRequired,
    showCurrentDocument: PropTypes.bool.isRequired,
    showDocumentationType: PropTypes.bool.isRequired,
    url: PropTypes.string,
    isMifid2Document: PropTypes.bool,
    mifid2SendEmailButton: PropTypes.bool,
    documentWithNoDates: PropTypes.bool,
    isStatementMail: PropTypes.bool,
    hideDateCell: PropTypes.bool,
    setSelectedDocument: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
};

DocumentRow.defaultProps = {
    hideDateCell: false,
    mifid2SendEmailButton: false,
    documentWithNoDates: false
};

module.exports.constructor = DocumentRow;

module.exports.DocumentRow = connect(
    state => ({
        immProfile: state.profile
    }),
    {
    }
)(withRouter(DocumentRow));
